{
  "fr": {
    "published": {
      "labels": {
        "publishedCustomerPartners": "Publié pour les clients et les partenaires",
        "publishedCustomer": "Publié pour les clients",
        "publishedPartners": "Publié pour les partenaires",
        "notPublished": "Non publié"
      },
      "publish_mode": {
        "inherit": "Suivre le modèle",
        "inherit_info": "Conserver l'état publié ou non publié de chaque élément du modèle",
        "publish": "Publier pour les clients",
        "publish_info": "Les clients les voient immédiatement",
        "title": "Publication",
        "unpublished": "Créer sans publier",
        "unpublished_info": "Masqués pour les clients jusqu'à la publication"
      }
    }
  }
}
